import { AuthFormValues } from '../../utils/form-validation.ts';
import { FormikErrors } from 'formik';
import { Link } from '@mui/material';

interface AddCitiesButtonProps {
  addedCities: string[];
  setAddedCities: (val: string[]) => void;
  values: AuthFormValues;
  setFieldValue: (
    field: string,
    value: string
  ) => Promise<void | FormikErrors<AuthFormValues>>;
}

export const AddCitiesButton = ({
  addedCities,
  setAddedCities,
  values,
  setFieldValue,
}: AddCitiesButtonProps) => {
  return (
    <Link
      sx={{
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '8px',
      }}
      onClick={() => {
        if (values.citiesBuildLocation !== '') {
          setAddedCities([values.citiesBuildLocation, ...addedCities]);
          void setFieldValue('citiesBuildLocation', '');
        }
      }}
      href="#"
      className="forgot-password"
    >
      + Add another city{' '}
    </Link>
  );
};
